import script from "./headers.vue?vue&type=script&setup=true&lang=js"
export * from "./headers.vue?vue&type=script&setup=true&lang=js"

import "./headers.vue?vue&type=style&index=0&id=379e6f4b&lang=css"

const __exports__ = script;

export default __exports__